export class JwtHelper {
  /**
   * Decodifica um token JWT sem verificar a assinatura
   * @param token Token JWT
   * @returns Payload decodificado ou null se inválido
   */
  static decodeToken(token: string): any {
    try {
      const base64Url = token.split('.')[1];
      if (!base64Url) {
        return null;
      }
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('Erro ao decodificar token JWT:', e);
      return null;
    }
  }

  /**
   * Verifica se o usuário é conferidor baseado no token JWT
   * @param token Token JWT
   * @returns true se isConferidor === 1, false caso contrário
   */
  static isConferidor(token: string): boolean {
    if (!token) {
      return false;
    }
    const decoded = this.decodeToken(token);
    return decoded && decoded.isConferidor === 1;
  }

  static podeExcluirMatricula(token: string): boolean {
    if (!token) {
      return false;
    }
    const decoded = this.decodeToken(token);
    return !!decoded && Number(decoded.podeExcluirMatricula) === 1;
  }

  static podeEditarServidorConferido(token: string): boolean {
    if (!token) {
      return false;
    }
    const decoded = this.decodeToken(token);
    return !!decoded && Number(decoded.podeEditarServidorConferido) === 1;
  }

  static origemAcesso(token: string): 'BRPREV' | 'MUNICIPIO' | null {
    const decoded = token ? this.decodeToken(token) : null;
    return decoded && (decoded.origem_acesso === 'BRPREV' || decoded.origem_acesso === 'MUNICIPIO')
      ? decoded.origem_acesso
      : null;
  }

  static isAdmin(token: string): boolean {
    const decoded = token ? this.decodeToken(token) : null;
    if (!decoded) return false;
    if (Number(decoded.isAdmin) === 1 || decoded.tipo_usuario === 'ADMIN') return true;
    // Tokens administrativos emitidos antes dos novos claims carregavam apenas
    // isConferidor=0. Tokens municipais antigos não possuíam essa propriedade.
    return decoded.tipo_usuario == null && decoded.isAdmin == null &&
      decoded.isConferidor !== undefined && Number(decoded.isConferidor) === 0;
  }

  static somenteLeituraMunicipio(token: string): boolean {
    return this.origemAcesso(token) === 'MUNICIPIO';
  }
}








